import './Header.scss';

import { mdiMenu } from '@mdi/js';
import { MAIN_IMAGE_ROOT } from 'app_config';
import { useGetCompanyAndUserInfoQuery } from 'common/queries';
import useAuth from 'common/useAuth';
import RecentHistoryMenu from 'components/AppShell/RecentHistoryMenu';
import Button from 'components/Button/Button';
import AdminHeader from 'components/Header/AdminHeader';
import UserHeader from 'components/Header/UserHeader';
import Icon from 'components/Icon/Icon';
import { PageToolbarSlot } from 'components/Layout/PageToolbar';
import { useCustomTranslation } from 'helpers/translationHelper';
import React from 'react';
import { Link } from 'react-router-dom';
import logo from 'static/images/logo_light.png';

// import logo from "static/images/logo_christmas_light.png";
import ImageComponent from '../ImageComponent/ImageComponent';
import UserMenu from './UserMenu';
import UserNotifications from './UserNotifications';

interface HeaderProps {
  variant?: 'full' | 'utilities';
  mobileNavigation?: { open: boolean; onOpen: () => void };
}

const Header = ({ variant = 'full', mobileNavigation }: HeaderProps): React.ReactElement => {
  const { tCommon } = useCustomTranslation();
  const utilitiesOnly = variant === 'utilities';
  const { loading } = useAuth();

  const companyAndUserQuery = useGetCompanyAndUserInfoQuery();
  const companySettings = companyAndUserQuery.data?.company;
  const user = companyAndUserQuery.data?.user;
  const restrictTechnicianDataVisibility =
    companyAndUserQuery.data?.company.restrictTechnicianDataVisibility;

  return (
    <header
      className={`Header${utilitiesOnly ? ' Header--utilities' : ''}`}
      aria-label={
        utilitiesOnly
          ? tCommon('navigation_utilities', { defaultValue: 'Uživatelská lišta' })
          : tCommon('navigation_top', { defaultValue: 'Horní navigace' })
      }
    >
      {mobileNavigation && (
        <Button
          type="text"
          className="Header_navigationTrigger"
          onClick={mobileNavigation.onOpen}
          aria-label={tCommon('navigation_open', { defaultValue: 'Otevřít navigaci' })}
          aria-expanded={mobileNavigation.open}
          aria-controls="app-navigation"
        >
          <Icon path={mdiMenu} />
        </Button>
      )}
      {(!utilitiesOnly || mobileNavigation) && (
        <Link to="/" className="logo">
          {companySettings?.headerLogoUrl ? (
            <ImageComponent url={`${MAIN_IMAGE_ROOT}${companySettings.headerLogoUrl}`} alt="logo" />
          ) : (
            <ImageComponent url={logo} alt="logo" />
          )}
        </Link>
      )}
      {!utilitiesOnly && (
        <nav className="main-nav">
          {!loading &&
            user &&
            (user.isSuperAdmin ? (
              <AdminHeader />
            ) : (
              <UserHeader
                user={user}
                hideStores={companySettings?.hideStores}
                restrictTechnicianDataVisibility={restrictTechnicianDataVisibility}
              />
            ))}
        </nav>
      )}
      {utilitiesOnly && <PageToolbarSlot />}
      <div className="right">
        <RecentHistoryMenu variant="header" />
        {!user?.isSuperAdmin && <UserNotifications />}
        <UserMenu />
      </div>
    </header>
  );
};

export default Header;
